import type { QuestId } from './site';

export interface Hotspot {
  n: number;
  x: number; // % from left of the map image
  y: number; // % from top
}

export interface QuestMap {
  src: string;
  ratio: string; // CSS aspect-ratio of the map image
  photoBase: string; // location photos live here: `${photoBase}/${n}.jpg`
  hotspots: Hotspot[];
}

// Maps are the left panel of algarve-quests/<quest>-treasure-map(-sand)-clean.jpg,
// cropped to (96,328)-(1599,1669). Hotspots are polaroid centres in % of that
// crop, measured by white-frame detection.
export const QUEST_MAPS: Partial<Record<QuestId, QuestMap>> = {
  faro: {
    src: '/maps/faro.jpg',
    ratio: '1503 / 1341',
    photoBase: 'https://play.algarve-quest.com/quests/faro',
    // Centres measured from the composited map (white-polaroid detection).
    hotspots: [
      { n: 1, x: 14.0, y: 12.2 },
      { n: 2, x: 32.1, y: 8.5 },
      { n: 3, x: 11.4, y: 29.9 },
      { n: 4, x: 48.5, y: 42.8 },
      { n: 5, x: 26.3, y: 24.7 },
      { n: 6, x: 33.0, y: 40.5 },
      { n: 7, x: 18.1, y: 45.5 },
      { n: 8, x: 26.5, y: 83.8 },
      { n: 9, x: 17.5, y: 63.1 },
      { n: 10, x: 32.4, y: 67.6 },
      { n: 11, x: 57.1, y: 57.5 },
      { n: 12, x: 43.0, y: 88.0 },
      { n: 13, x: 47.7, y: 71.5 },
      { n: 14, x: 70.7, y: 48.8 },
      { n: 15, x: 58.5, y: 89.9 },
      { n: 16, x: 87.0, y: 90.0 },
    ],
  },
  olhao: {
    src: '/maps/olhao.jpg',
    ratio: '1503 / 1341',
    photoBase: 'https://play.algarve-quest.com/quests/olhao',
    hotspots: [
      { n: 1, x: 7.0, y: 79.1 },
      { n: 2, x: 7.0, y: 61.6 },
      { n: 3, x: 16.0, y: 47.3 },
      { n: 4, x: 36.1, y: 37.4 },
      { n: 5, x: 48.4, y: 26.5 },
      { n: 6, x: 59.6, y: 38.6 },
      { n: 7, x: 74.9, y: 34.9 },
      { n: 8, x: 90.3, y: 37.6 },
      { n: 9, x: 90.5, y: 20.1 },
      { n: 10, x: 90.5, y: 55.3 },
      { n: 11, x: 75.0, y: 52.5 },
      { n: 12, x: 47.4, y: 67.9 },
      { n: 13, x: 32.7, y: 54.5 },
    ],
  },
  alte: {
    src: '/maps/alte.jpg',
    ratio: '1503 / 1341',
    photoBase: 'https://play.algarve-quest.com/quests/alte',
    hotspots: [
      { n: 1, x: 41.8, y: 17.7 },
      { n: 2, x: 56.2, y: 11.2 },
      { n: 3, x: 71.7, y: 8.5 },
      { n: 4, x: 90.6, y: 8.5 },
      { n: 5, x: 90.5, y: 36.6 },
      { n: 6, x: 74.5, y: 38.3 },
      { n: 7, x: 81.0, y: 22.5 },
      { n: 8, x: 60.5, y: 29.9 },
      { n: 9, x: 51.7, y: 51.2 },
      { n: 10, x: 40.6, y: 35.1 },
      { n: 11, x: 36.3, y: 53.9 },
      { n: 12, x: 36.7, y: 72.0 },
      { n: 13, x: 22.2, y: 61.1 },
      { n: 14, x: 22.2, y: 78.5 },
      { n: 15, x: 6.9, y: 56.8 },
      { n: 16, x: 7.0, y: 74.4 },
    ],
  },
};
